import { render, staticRenderFns } from "./IdentityAuthenticate.vue?vue&type=template&id=43c75321&scoped=true"
import script from "./IdentityAuthenticate.vue?vue&type=script&lang=js"
export * from "./IdentityAuthenticate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c75321",
  null
  
)

export default component.exports